module.exports = __webpack_public_path__ + "media/images/doodle-faces-f39d7a5bf59857488836f407f950245e.png";